import React, { useContext, useState } from 'react';
import { styled } from 'linaria/react';
import { useMutation } from '@apollo/react-hooks';
import { useFormikContext } from 'formik';

import t from '@jetshop/intl';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import {
  addToCartSuccess,
  useTrackProductAdd
} from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import { useNotification } from '@jetshop/core/components/Notifications';

import ProductToastWrapper from './ProductToast';
import { addToCart } from '../../../Cart/queries/addToCart.gql';
// import { SVG } from '../../../../assets/SVG';
import { CTA } from 'r3-lib/dist/r3lib';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';

const AddToCartQtyButtonContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  grid-gap: 5px;

  .button-wrapper {
    display: flex;
    justify-content: space-between;
    flex: 1;

    .cta {
      width: 100%;
      height: 40px;
      text-transform: uppercase;
      border-radius: 3px;
      svg {
        margin-right: 10px;
        margin-top: -3px;
        width: 15px;
      }
    }
  }
`;

// const AddToCartButton = styled('button')`
//   background: #004e42;
//   color: white;
//   height: 40px;
//   padding: 4px 0 0 0;
//   margin: 0;
//   border: 0;
//   appearance: none;
//   font-weight: bold;
//   font-size: 12px;
//   width: 100%;
//   text-transform: uppercase;
//   letter-spacing: 1px;
//   svg {
//     margin-right: 10px;
//     margin-top: -3px;
//     width: 15px;
//   }
// `;

const QtyAdjusterContainer = styled('div')`
  display: flex;
  align-items: center;

  button {
    width: 100%;
    width: 40px;
    height: 45px;
    background: #dbdfe0;
    font-size: 30px;
    font-weight: 300;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #282828;
    font-size: 14px;
    font-weight: normal;
  }

  input {
    border: none;
    width: 25px;
    height: 45px;
    background: #dbdfe0;
    text-align: center;
    font-size: 12px;
    color: #282828;
    &:focus {
      outline: none;
      border: 0;
    }

    /* --> Remove standard buttons from input <-- */
    /* Chrome, Safari, Edge, Opera */
    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    [type='number'] {
      -moz-appearance: textfield;
    }

    :focus {
      outline: none;
      border: 1px solid black;
    }
  }
`;

export const AddToCartQtyButton = ({
  product,
  variant,
  productPage,
  outOfStockNotify,
  validationMessage
}) => {
  const [qty, setQty] = useState(1);
  const { cartId, setCartId } = useContext(CartIdContext);
  const articleNumber = variant?.articleNumber ?? product.articleNumber;
  const price = {
    price: variant?.price ?? product.price,
    previousPrice: variant?.previousPrice ?? product.previousPrice
  };

  const trackAddProductVariant = useTrackProductAdd(variant ?? product);

  const [trigger] = useNotification();
  const { values } = useFormikContext();

  const commentCreator = vals => {
    const totalCommentsArray = [];
    const commentsArray = Object.entries(vals?.comments);
    commentsArray.forEach(comment => {
      const key = comment?.[0];
      const value = comment?.[1];
      let commentObj = {};
      commentObj['name'] = key;
      commentObj['value'] = value;

      totalCommentsArray.push({ ...commentObj });
    });

    return totalCommentsArray;
  };

  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: qty,
        comments: commentCreator(values)
      }
    },
    onCompleted: data => {
      trigger(
        <ProductToastWrapper
          selectedVariation={variant}
          product={product}
          quantity={qty}
          price={price}
        />,
        { type: 'add-to-cart' }
      );

      trackAddProductVariant(product, qty);

      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });

  const { loggedIn } = useAuth();
  return (
    <>
      <AddToCartQtyButtonContainer className="add-to-cart-qty-button-container">
        <QtyAdjuster qty={qty} setQty={setQty}></QtyAdjuster>
        {productPage ? (
          <div className="button-wrapper">
            {!outOfStockNotify && (
              <CTA
                testid="add-to-cart"
                className={'accent'}
                clickCallback={() => {
                  if (loggedIn) {
                    add();
                  }
                }}
              >
                <>
                  {/* <SVG name="Cart" /> */}
                  {validationMessage
                    ? validationMessage
                    : loggedIn
                    ? t('Add to cart')
                    : t('Log in to buy')}
                </>
              </CTA>
            )}
          </div>
        ) : (
          <CTA
            className={'accent'}
            clickCallback={() => {
              if (loggedIn) {
                add();
              }
            }}
          >
            <>
              {/* <SVG name="Cart" /> */}
              {validationMessage ? validationMessage : t('Add to cart')}
            </>
          </CTA>
        )}
      </AddToCartQtyButtonContainer>
    </>
  );
};

export const QtyAdjuster = ({ qty = 1, setQty }) => {
  return (
    <QtyAdjusterContainer className="qty-adjuster">
      <button
        disabled={qty < 2}
        onClick={e => {
          e.preventDefault();
          setQty(qty - 1);
        }}
      >
        –
      </button>
      <input
        value={qty}
        type={'number'}
        onChange={e => {
          const value = e?.currentTarget?.value;
          const newInt = parseInt(value);
          const notNumber = isNaN(newInt);

          if (!notNumber) {
            setQty(newInt);
          }
        }}
      />
      <button
        onClick={e => {
          e.preventDefault();
          setQty(qty + 1);
        }}
      >
        +
      </button>
    </QtyAdjusterContainer>
  );
};
